<template>
    <el-dialog :visible.sync="detailDialogShow" width="auto" class="goods_detail_dialog" @close="closeDialog">
        <div class="custom_dialog">
            <div class="dialog_header">
                <span></span>
                <span class="dialog_title">{{ $t('goodsDetail') }}</span>
                <span class="dialog_close" @click="closeDialog">&times;</span>
            </div>
            <div v-if="allGearData && allGearData.currencyList && allGearData.currencyList.length > 0" class="detail_box">
                <div>
                    <div class="detail_icon" :style="{ 'backgroundImage': 'url(' + detailData.goodsIcon + ')' }"></div>
                </div>
                <div class="detail_info">
                    <p class="detail_name">{{ detailData.iapName }}</p>
                    <p class="detail_content">{{ detailData.iapContent }}</p>
                    <el-button v-if="isLogin" class="detail_point" type="danger" size="small"
                        @click.stop="plusNum(detailData)"
                        :disabled="detailData.limitNum !== 0 && (detailData.amount == detailData.limitNum)">{{ unit + ' ' +
                            pcgJsonData[detailData.price]}}</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    props: {
        detailData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        unit: {
            type: String,
            default: ''
        },
        isLogin: {
            type: Boolean,
            default: false
        },
        pcgJsonData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            detailDialogShow: true,
        }
    },
    computed: {
        ...mapGetters(['allGearData',]),
    },
    methods: {
        plusNum(data) {
            this.$emit('plusNum', data)
        },
        closeDialog() {
            this.$emit('closeDialog')
        }
    }
}
</script>
<style lang="scss" scoped>
.goods_detail_dialog {
    ::v-deep {
        .el-dialog {
            background: transparent !important;
            box-shadow: none !important;
            width: auto !important;
            max-width: 90vw;
            margin: 0 auto;
        }
        .el-dialog__header {
            display: none !important;
        }
        .el-dialog__body {
            padding: 0 !important;
            background: transparent !important;
        }
        .el-dialog__footer {
            display: none !important;
        }
        .el-dialog__wrapper {
            background: rgba(0, 0, 0, 0.5);
        }
    }

    .custom_dialog {
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        min-width: 400px;
        max-width: 600px;
        width: auto;
        display: inline-block;
    }

    .dialog_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 20px;
        // border-bottom: 1px solid #ebeef5;
        // background: #f5f7fa;
        border-radius: 8px 8px 0 0;
    }

    .dialog_title {
        font-size: 18px;
        font-weight: bold;
        color: #303133;
    }

    .dialog_close {
        font-size: 24px;
        color: #909399;
        cursor: pointer;
        line-height: 1;
        transition: color 0.3s;

        &:hover {
            color: #409eff;
        }
    }

    .detail_box {
        display: flex;
        gap: 20px;
        padding: 20px;
        align-items: flex-start;
    }

    .detail_icon {
        background-size: 100% auto !important;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        width: 153px;
        height: 153px;
        margin: 0 auto;
        flex-shrink: 0;
    }

    .detail_info {
        flex: 1;
        min-width: 0;
    }

    .detail_name {
        text-align: left;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 10px;
    }

    .detail_content {
        word-break: break-all;
        white-space: pre-wrap;
        overflow-y: auto;
        text-align: left;
        max-height: 150px;
        min-height: 60px;
        font-size: 12px;
        width: 100%;
        // 滚动条宽度调整
        &::-webkit-scrollbar {
            width: 8px;
            /*高宽分别对应横竖滚动条的尺寸*/
        }

        &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 5px;
            background: #c0c0c0;
        }

        &::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            border-radius: 6px;
            background: #f9f9f9;
        }
    }

    .detail_point {
        font-size: 18px;
        text-align: center;
        width: 150px;
        border-radius: 20px;
        background-color: #d32e26;
        border-color: #d32e26;
        margin-top: 10px;
    }
}
</style>